module.exports = __webpack_public_path__ + "static/media/light_icn_map_pin_bus_lex.0e6c9e7e.svg";